export default "__VITE_ASSET__17292d46__"